import React from 'react';
import { Link } from 'react-router-dom';
import { PublicAnimal } from '../../services/api';
import LazyImage from '../../components/UI/LazyImage';

interface DogCardProps {
  dog: PublicAnimal;
}

const DogCard: React.FC<DogCardProps> = ({ dog }) => {
  // Convert backend gender format to display format
  const displayGender = dog.gender === 'male' ? 'Mascul' : 'Femelă';
  
  // Convert backend size to display format
  const displaySize = dog.size === 'mic' ? 'Mic' : 
                     dog.size === 'mediu' ? 'Mediu' : 'Mare';

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-lg transition-shadow">
      <div className="relative overflow-hidden flex items-center justify-center">
        <Link to={`/caini/${dog.id}`}>
          <LazyImage
            src={dog.image}
            alt={`${dog.name} - ${dog.gender === 'male' ? 'câine mascul' : 'câine femelă'} pentru adopție în București`}
            className="w-full h-48 transition-transform duration-500 group-hover:scale-105"
            objectFit="cover"
            loading="lazy"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            width={300}
            height={192}
          />
        </Link>
      </div>
      
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <Link to={`/caini/${dog.id}`} className="hover:text-accent transition-colors">
            <h3 className="text-lg font-bold text-primary">{dog.name}</h3>
          </Link>
        </div>
        
        <div className="grid grid-cols-3 gap-2 mb-3">
          <div>
            <span className="text-xs text-gray-500 block">Gen:</span>
            <span className="text-sm font-medium">{displayGender}</span>
          </div>
          <div>
            <span className="text-xs text-gray-500 block">Vârstă:</span>
            <span className="text-sm font-medium">{dog.age}</span>
          </div>
          <div>
            <span className="text-xs text-gray-500 block">Talie:</span>
            <span className="text-sm font-medium">{displaySize}</span>
          </div>
        </div>
        
        <p className="text-sm text-gray-600 line-clamp-2 mb-4">
          {dog.description}
        </p>
        
        <div className="flex justify-between items-center mb-4">
          <div className="flex space-x-1">
            {dog.vaccinated && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Vaccinat
              </span>
            )}
            {dog.neutered && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                Sterilizat
              </span>
            )}
            {dog.chipped && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                Cipat
              </span>
            )}
          </div>
        </div>
        
        <Link
          to={`/caini/${dog.id}`}
          className="w-full bg-primary text-white text-center py-2 px-4 rounded-md hover:bg-primary-dark transition-colors inline-block"
        >
          Vezi detalii
        </Link>
      </div>
    </div>
  );
};

export default DogCard;